import React from 'react';
import { connect } from 'react-redux';
import Typography from '@mui/material/Typography';
import { withStyles } from 'tss-react/mui';

const styles = () => ({
  textStyle: {
    whiteSpace: 'pre-line',
    textAlign: 'center',
  },
});

const mapStateToProps = ({
  dialog: {
    contentProps: { message },
  },
}) => ({
  message,
});

const VerficationProp = ({ message, classes }) => (
  <Typography
    className={classes.textStyle}
    variant="subtitle1"
    children={message}
  />
);

export default connect(mapStateToProps)(
  withStyles(VerficationProp, styles)
);
